import react, { useEffect, useState } from "react";
import { Sidebar } from "./layout/Sidebar";
import { Contents } from "./layout/Contents";
// import DisasterAdd from "./components/DisasterList/DisasterAdd";
import RendezvousMgr from "./components/Modal/Rendezvous";
import MFlistExcelInput from "./components/Modal/MflistExcelinput";
import { Box, Stack } from "@mui/material";
import { sbHeightCtx } from "./store/sidebarWiHeContext";
import { Navbar } from "./layout/Navbar";
import { createChatSocket } from "./utils/chatSocket";
import Login from "./components/Login/Login";
import QRmanager from "./components/Modal/QRmanager";
import DashboardPage from "./pages/DashboardPage";
import ComparePage from "./pages/ComparePage";
import ActivityTypesConfigModal from "./components/Settings/ActivityTypesConfigModal";

///////////// socket.io //////////////
const socket = createChatSocket();
///////////// socket.io //////////////

const Home = (props) => {
  let sbContainerHeight = window.innerHeight - 65; // 65 is the height of the navbar
  const [height, setHeight] = useState(sbContainerHeight);
  let sbContainerWidth = ((window.innerWidth * 2) / 12) * 0.9;
  const [width, setWidth] = useState(sbContainerWidth);

  useEffect(() => {
    const onResize = () => {
      setHeight(window.innerHeight - 65);
      setWidth(((window.innerWidth * 2) / 12) * 0.9);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    // 다른 탭(자원관리앱 등)에서 설정한 재난 기준값 보존 후 clear → stsync 수신 시 사인보드 갱신 유지
    const preserveOndsid = sessionStorage.ondsid;
    const preserveSelectedDSid = sessionStorage.selectedDSid;
    const preserveMfmid = sessionStorage.mfmid;
    sessionStorage.clear();
    if (preserveOndsid != null && preserveOndsid !== "") sessionStorage.ondsid = preserveOndsid;
    if (preserveSelectedDSid != null && preserveSelectedDSid !== "") sessionStorage.selectedDSid = preserveSelectedDSid;
    if (preserveMfmid != null && preserveMfmid !== "") sessionStorage.mfmid = preserveMfmid;
  }, []);

  ///////////// socket.io //////////////
  useEffect(() => {
    const onSignboardRefresh = () => setViewSGN(+new Date());
    window.addEventListener("mfSignboardRefresh", onSignboardRefresh);
    return () => window.removeEventListener("mfSignboardRefresh", onSignboardRefresh);
  }, []);
  useEffect(() => {
    socket.on("stsync", (data) => {
      // 소켓서버에서 보낸 자료를 받음
      const { sort, inputuser, dsid, org, eqp, csgn, time, time2, transtxt } = data;
      sessionStorage.ondsid == undefined
        ? (sessionStorage.ondsid = "")
        : (sessionStorage.ondsid = sessionStorage.ondsid.trim());

      // stateChaged 시 자원관리앱(다른 탭)에서 온 메시지: ondsid가 비어 있으면 수신 dsid로 보정해 사인보드 갱신 보장
      const dsidTrim = (dsid != null && dsid !== undefined) ? String(dsid).trim() : "";
      if (sort === "stateChaged" && dsidTrim && !sessionStorage.ondsid.trim()) {
        sessionStorage.ondsid = dsidTrim;
      }

      const ondsidTrim = sessionStorage.ondsid.trim();
      const dsidMatches = dsidTrim && ondsidTrim && dsidTrim === ondsidTrim;

      // 현재 선택된 재난과 일치하는 경우에만 처리
      if (dsidMatches) {
        sessionStorage.refreshSort = sort;
        sessionStorage.refreshOrg = org;
        sessionStorage.refreshEqp = eqp;
        sessionStorage.refreshCsgn = csgn;
        if (sort == "stateChaged") {
          // 상태만 변경이면 (지도는 이동하지 않음)
          setStatchanged(+new Date()); // 상황판·동원자원 갱신 (지원인력 패널은 출퇴근·rdvattendance 시에만 refreshBrd)
          // 상태 변경 직후 즉시 refetch 시 API가 빈 배열을 반환함. 백엔드 반영 후 조회하도록 짧게 지연.
          const viewSGNToken = +new Date();
          setTimeout(() => setViewSGN(viewSGNToken), 200);
          if (
            data.snum != null ||
            data.seqnum != null ||
            data.mfstatus != null
          ) {
            window.dispatchEvent(
              new CustomEvent("mfStatusChanged", {
                detail: {
                  dsid: dsidTrim,
                  snum: data.snum,
                  seqnum: data.seqnum,
                  mfstatus: data.mfstatus,
                },
              }),
            );
          }
          // 지령상태이력은 DB 전체 조회 없이 한 건만 추가 (자원등록앱/다른 탭에서의 상태변경 포함)
          if (typeof window.dispatchEvent === "function") {
            const now = new Date();
            const ipdt = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;
            window.dispatchEvent(new CustomEvent("mfHistoryRowAdded", {
              detail: {
                dsid: dsid || "",
                row: {
                  kind: "status",
                  mfeqp: (eqp != null && eqp !== undefined) ? String(eqp) : "",
                  mfdorg: (org != null && org !== undefined) ? String(org) : "",
                  mfcsgn: (csgn != null && csgn !== undefined) ? String(csgn) : "",
                  content: transtxt || "상태 변경",
                  ipdt,
                },
              },
            }));
          }
        } else {
          // 전체변경이면
          onSelectDSHandler();
        }
      }
    });
    socket.on("rdvattendance", (data) => {
      const dsid = data?.dsid;
      const ondsid = (sessionStorage.ondsid || "").toString().trim();
      if (!dsid || dsid === ondsid) {
        setViewSGN(+new Date());
        setRefreshBrd(+new Date());
        window.dispatchEvent(new CustomEvent("rdvAttendanceRefresh", { detail: { dsid: dsid || ondsid } }));
      }
    });
  }, []);

  // const sendsync = () => {  // 소캣서버로 자료를 보냄
  //   const param = {
  //     name: "인천",
  //     msg: 20
  //   }
  //   socket.emit("stsync", param);
  // };

  const callrefresh = (sort, time2) => {
    sort == "input"
      ? console.log("new input" + " // " + time2)
      : console.log("state change" + " // " + time2);
    // sort == "input" ? setMflist(+ new Date()) : "";
  };
  ///////////// socket.io //////////////

  const [login, setLogin] = useState(false); // 로그인 여부
  const [onSelectDS, setOnSelectDS] = useState(Math.random()); // 선택된 재난정보
  const [mode, setMode] = useState("light");
  const [dsAddShown, setDsAddShown] = useState(false);
  const [onstatus, setOnstatus] = useState("");
  const [start, setStart] = useState(false); // 상황시작 여부(각종 컴포넌트 표시 여부)
  const [viewSGN, setViewSGN] = useState(""); // 상단상황판 갱신용
  const [viewMFP, setViewMFP] = useState(true); // 동원자원 목록 표출 여부
  const [statchanged, setStatchanged] = useState(""); // 상황판 명칭만 갱신
  const [mapfresh, setMapfresh] = useState(""); // 지도 갱신용
  const [refreshBrd, setRefreshBrd] = useState(""); // 상황판 갱신용
  const [refreshChat, setRefreshChat] = useState(""); // 채팅 갱신용
  const [viewmaptool, setViewmaptool] = useState(false); // 지도툴 표출 여부
  const [fullswitch, setFullswitch] = useState(false); // 전체보기/숨기기 스위치
  const [dashboardModalOpen, setDashboardModalOpen] = useState(false);
  const [compareModalOpen, setCompareModalOpen] = useState(false);
  const [activityTypesConfigOpen, setActivityTypesConfigOpen] = useState(false);
  const [signboardStatusFilter, setSignboardStatusFilter] = useState(null); // 사인보드 클릭 시 동원자원 상세 필터: 'all' | 0 | 1 | 2 | 3 | 9
  const [sidebarExpanded, setSidebarExpanded] = useState(true); // 재난관리 패널 펼침 여부(상황판 left 위치용)
  const [requestOpenSupportPanel, setRequestOpenSupportPanel] = useState(0); // 지원인력 사인보드 클릭 시 지원인력 상세패널 열기 요청 (timestamp)

  const showDsAddModal = () => {
    setDsAddShown(true);
  };
  const showRDVModal = () => {
    if (typeof sessionStorage !== "undefined") sessionStorage.modalSort = "RDV";
    setDsAddShown(true);
  };
  const hideDsAddModal = () => {
    if (typeof sessionStorage !== "undefined" && sessionStorage.modalSort === "RDV") {
      window.dispatchEvent(new CustomEvent("rdvListRefresh"));
    }
    setDsAddShown(false);
  };

  const onChangeStatus = (e) => {
    setOnstatus(e);
    setStart(true); // 상황시작(각종 컴포넌트 표시)
  };

  const onSelectDSHandler = () => {
    console.log("재난이 선택되었습니다. 상황판갱신이 필요합니다.");
    let nts = +new Date();
    setOnSelectDS(nts);
    setViewSGN(nts);
    setRefreshBrd(nts);
    setRefreshChat(nts);
    setViewmaptool(true);
  };

  const hideMFlist = () => {
    setViewMFP(false); // 동원자원 목록 숨기기
    setSignboardStatusFilter(null); // 사인보드 필터 초기화
  };

  useEffect(() => {
    hideMFlist();
  }, []);

  const viweMFlist = () => {
    setViewMFP(true); // 동원자원 목록 표출
  };

  const openMfWithFilter = (statusFilter) => {
    if (statusFilter === "support") {
      // 지원인력 사인보드 클릭 → 지원인력 상세패널 열기
      setRequestOpenSupportPanel(Date.now());
      return;
    }
    if (typeof sessionStorage !== "undefined") {
      sessionStorage.selectedOrg = "sum";
      sessionStorage.selectedEqp = "";
    }
    setSignboardStatusFilter(statusFilter);
    setViewMFP(true);
  };

  const mapfreshHandler = () => {
    setMapfresh(Math.random());
  };

  const loginHandler = () => {
    setLogin(true);
  };

  const fullviewChangeHandler = (ox) => {
    // 전체보기/숨기기 설정
    if (ox == true) {
      sessionStorage.fullswitch = true;
      setFullswitch(true);
    } else {
      sessionStorage.fullswitch = false;
      setFullswitch(false);
    }
  };

  return (
    <sbHeightCtx.Provider value={{ width, height, onSelectDS }}>
      {!login && <Login apiAddr={props.apiAddr} loginox={loginHandler} />}
      {login && (
        <Box
          bgcolor={"background.default"}
          color={"text.primary"}
          sx={{ height: "100vh", overflow: "hidden", display: "flex", flexDirection: "column" }}
        >
          {/* // 집결지관리 모달보이기 */}
          {dsAddShown && sessionStorage.modalSort == "RDV" && (
            <RendezvousMgr onClose={hideDsAddModal} apiAddr={props.apiAddr} />
          )}
          {dsAddShown && sessionStorage.modalSort == "QR" && (
            <QRmanager onClose={hideDsAddModal} apiAddr={props.apiAddr} />
          )}
          {dsAddShown && sessionStorage.modalSort == "MFexcelinput" && (
            <MFlistExcelInput
              onClose={hideDsAddModal}
              apiAddr={props.apiAddr}
              onSelectDS={onSelectDSHandler}
            />
          )}
          <Navbar
            onStatus={onstatus}
            onShowDS={showDsAddModal}
            apiAddr={props.apiAddr}
            hdmf={props.hdmf}
            fullswitch={fullviewChangeHandler}
            viewmaptool={viewmaptool}
            onOpenDashboard={() => setDashboardModalOpen(true)}
            onOpenCompare={() => setCompareModalOpen(true)}
            onOpenActivityTypesConfig={() => setActivityTypesConfigOpen(true)}
          />
          {activityTypesConfigOpen && (
            <ActivityTypesConfigModal
              open={activityTypesConfigOpen}
              onClose={() => setActivityTypesConfigOpen(false)}
              apiAddr={props.apiAddr}
            />
          )}
          {dashboardModalOpen && (
            <Box
              sx={{
                position: "fixed",
                top: "60px",   /* 사인보드(60px) 아래부터 시작 */
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1299,
                bgcolor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: "2vh 5vw",
                boxSizing: "border-box",
              }}
              onClick={(e) => e.target === e.currentTarget && setDashboardModalOpen(false)}
            >
              <Box
                sx={{
                  width: "90vw",
                  height: "calc(100% - 4vh)",
                  maxWidth: "90vw",
                  bgcolor: "background.paper",
                  overflow: "auto",
                  borderRadius: 2,
                  boxShadow: 3,
                  zIndex: 1300,
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <DashboardPage apiAddr={props.apiAddr} onClose={() => setDashboardModalOpen(false)} />
              </Box>
            </Box>
          )}
          {compareModalOpen && (
            <Box sx={{ position: "fixed", inset: 0, zIndex: 1300, bgcolor: "background.paper", overflow: "auto" }}>
              <ComparePage apiAddr={props.apiAddr} onClose={() => setCompareModalOpen(false)} />
            </Box>
          )}
          <Stack direction="row" spacing={1} justifyContent="space-between" sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
            <Sidebar
              setMode={setMode}
              mode={mode}
              onShowDS={showDsAddModal}
              onShowRDV={showRDVModal}
              apiAddr={props.apiAddr}
              onStatus={onChangeStatus}
              onSelectDS={onSelectDSHandler}
              hdmf={hideMFlist}
              mapfresh={mapfreshHandler}
              fullswitch={fullswitch}
              onExpandChange={setSidebarExpanded}
            />
            <Contents
              apiAddr={props.apiAddr}
              start={start}
              viewSGN={viewSGN}
              onShowDS={showDsAddModal}
              hdmf={viewMFP}
              viewmf={viweMFlist}
              statechanged={statchanged}
              mapfresh={mapfresh}
              reqmapfresh={mapfreshHandler}
              hidemf={hideMFlist}
              refreshBrd={refreshBrd}
              refreshChat={refreshChat}
              viewmaptool={viewmaptool}
              fullswitch={fullswitch}
              onSignboardClick={openMfWithFilter}
              signboardStatusFilter={signboardStatusFilter}
              sidebarExpanded={sidebarExpanded}
              requestOpenSupportPanel={requestOpenSupportPanel}
              onStatus={onChangeStatus}
            />
          </Stack>
        </Box>
      )}
    </sbHeightCtx.Provider>
  );
};

export default Home;
